import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-settings-1-icon',
  templateUrl: './general-settings-1.component.html'
})
export class GeneralSettings1Component extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
